export default {
      id: "btn_info_new-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite.svg#btn_info_new",
      toString: function () {
        return this.url;
      }
    }